const API_KEY = 'pk.eyJ1IjoiamVzc2d1c2NsYXJrIiwiYSI6ImNqd29xdDVwNjEybGI0OXFtOWVka2NycWwifQ.7eDQFHFpwyDSr3JwngmCEA';
const ZOOM = '12'

export const getMapboxLink = (lat, long) => {
  // REFERENCE:
  // https://api.mapbox.com/styles/v1/{username}/{style_id}/static/{overlay}/{lon},{lat},{zoom},{bearing},{pitch}|{auto}|{bbox}/{width}x{height}{padding}{@2x}

  return `https://api.mapbox.com/styles/v1/mapbox/streets-v12/static/pin-s+555555(${long},${lat})/${long},${lat},${ZOOM},0/300x150?access_token=${API_KEY}`
}
